import { useEffect, useState } from "react";
import { useUpdateKlaviyoProperties } from "../hooks/useUpdateKlaviyoProperties";
import { Checkbox } from "@components/Checkbox";
import { NOTIFICATION_DATA } from "./lib/constants";
import styles from "./styles/Notifications.module.css";

const KLAVIYO_ERR = "Invalid data provided";
const ERROR_MSG = "Something went wrong, please refresh the page and try again.";

const allNotificationNames = NOTIFICATION_DATA.reduce((acc, cur) => {
  return [...acc, cur.sms, cur.email];
}, []);

const defaultValues = allNotificationNames.map((item) => ({ [item]: false }));

const filterNotifications = (obj, allowedProperties = []) => {
  return Object.keys(obj).reduce((next, key) => {
    if (allowedProperties.includes(key)) {
      return [...next, { [key]: obj[key] }];
    } else {
      return next;
    }
  }, []);
};

export const Notifications = ({ account, setSuccess }) => {
  const [list, setList] = useState(defaultValues);
  const [error, setError] = useState(null);
  const klaviyoUpdate = useUpdateKlaviyoProperties(account, setSuccess);

  useEffect(() => {
    if (account.klaviyoData === KLAVIYO_ERR) setError(ERROR_MSG);

    if (typeof account.klaviyoData !== "string") {
      const klaviyoValues = filterNotifications(account.klaviyoData, allNotificationNames);
      klaviyoValues.length ? setList(klaviyoValues) : setList(defaultValues);
    }

    return () => setList(defaultValues);
  }, [account.klaviyoData]);

  const getPreferenceObj = (name) => {
    return list.find((item) => {
      const val = Object.keys(item)[0];
      return val === name;
    });
  };

  const handleChange = (name) => {
    const updatedList = list.map((item) => {
      if (Object.keys(item)[0] === name) {
        return { [name]: !item[name] };
      }

      return item;
    });

    setList(updatedList);
  };

  const handleSubmit = () => {
    const values = list.reduce((acc, cur) => {
      const key = Object.keys(cur)[0];
      const value = Object.values(cur)[0];
      return { ...acc, [key]: value };
    }, {});

    klaviyoUpdate.mutate({
      $email: account.klaviyoData.$email,
      ...values,
    });
  };

  const Save = () => {
    return (
      <input
        className={`${styles.button} ${styles.primary}`}
        type="button"
        value="Save"
        onClick={handleSubmit}
      />
    );
  };

  const LineItem = ({ title, smsName, emailName }) => {
    const smsPreference = getPreferenceObj(smsName);
    const smsValue = smsPreference ? smsPreference[smsName] : false;

    const emailPreference = getPreferenceObj(emailName);
    const emailValue = emailPreference ? emailPreference[emailName] : false;

    return (
      <div className={styles.listItem}>
        <p>{title}</p>
        <section className={styles.inputs}>
          <Checkbox
            id={smsName}
            name={smsName}
            value={smsValue}
            checked={smsValue}
            onChange={() => handleChange(smsName)}
            label="SMS"
          />
          <Checkbox
            id={emailName}
            name={emailName}
            value={emailValue}
            checked={emailValue}
            onChange={() => handleChange(emailName)}
            label="Email"
          />
        </section>
      </div>
    );
  };

  return (
    <form className={styles.form}>
      <header className={styles.header}>
        <h3>Notification</h3>
        <h3>Type</h3>
      </header>
      <div className={styles.list}>
        {NOTIFICATION_DATA.map((item) => {
          return (
            <LineItem key={item.tag} title={item.title} smsName={item.sms} emailName={item.email} />
          );
        })}
      </div>
      <Save />
      {error && <p className={styles.error}>{error}</p>}
    </form>
  );
};
